<template>
    <vs-popup :active.sync="active" title="Delete">
        <vs-row class="mt-3">
            <vs-col>
                <h5 class="mb-base text-center block">Are you sure you want to delete this {{ type }}?, this action is not irreversible.</h5>
                <vs-col class="text-center mb-3">
                    <vs-button @click="$emit('delete_issue')" color="danger">Yes</vs-button>
                    <vs-button @click="active=false" color="primary" class="mx-2">No</vs-button>
                </vs-col>
            </vs-col>
        </vs-row>
    </vs-popup>
</template>

<script>
export default {
    props: {
        is_active: {
            type: Boolean,
            required: true,
            default: false
        },
        type: {
            type: String,
            default: '',
            required: false
        }
    },
    data() {
        return {
            active: this.is_active,
        }
    },
    watch: {
        active (newV, oldV) {
            if (newV !== oldV) this.$emit('update:is_active', newV)
        },
        is_active (newV, oldV) {
            if (newV !== oldV) this.active = newV
        }
    }
}
</script>